export const getEmailStatus = (email) => {
  if (email.length > 0 && !email.includes('@')) return 'error';
  if (email.length > 0 && email.includes('@')) return 'success';
  return 'default';
};

export const getEmailMessage = (email) => {
  if (email.length > 0 && !email.includes('@'))
    return 'Please enter a valid email';
  return '';
};

export const getPasswordStatus = (password) => {
  if (password.length === 0) return 'default';
  if (password.length > 0 && password.length < 8) return 'error';
  return 'success';
};

export const getPasswordMessage = (password) => {
  if (password.length > 0 && password.length < 8) {
    return 'Minimum 8 characters';
  }
  return 'Minimum 8 characters, letters & numbers';
};

export const isEmailValid = (email) => {
  return email.includes('@') && email.length > 0;
};

export const isPasswordValid = (password) => {
  return password.length >= 8;
};

